import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "department-documents",
  courseId: "for-agency-admins",
  order: 6,
  title: "Policy documents",
  subtitle: "Upload your department's rules",
  summary:
    "Upload the policy manual, directives, and municipal code so reports are written against your rules instead of generic state law. Sections are split and tagged automatically, and officers get a Policies page.",
  learn: [
    "Upload and track a document through processing",
    "Curate the tag vocabulary and per-section tags",
    "Preview what the AI would retrieve for an incident",
  ],
  minutes: 4,
  releasedAt: "2026-10-08T00:00:00.000Z",
  gate: "admin",
  body: [
    {
      type: "paragraph",
      text: "The Documents tab is where you give the AI your department's own rules. It is included in the agency plan with no extra seats.",
    },
    {
      type: "steps",
      items: [
        "Open the **Documents** tab and click **Upload**.",
        "Choose a document type and any tags to pin. PDF, Word, and text files work. Lexipol-style manuals and municipal code split best.",
        "Watch the upload tray: extract, section, tag, embed, done. A long manual takes a few minutes.",
        "Open the document. Each section shows its auto tags. Add or remove tags per section.",
        "Click **Manage tags** to rename or merge the department vocabulary.",
        "Click **Retrieval preview**, describe an incident, and see which sections the AI would hand the report writer.",
      ],
    },
    {
      type: "paragraph",
      text: "A tag you remove from a section is remembered, so a reprocess will not add it back. If the wrong sections surface in the preview, fix the tags and run it again. Use Reprocess on a document after tag changes, or to add section highlighting to an older upload. Delete removes it everywhere.",
    },
    {
      type: "callout",
      tone: "note",
      title: "What turns on",
      text: "The first completed document switches on three things for officers: policy retrieval at draft time, the policy check that posts \"[Policy check · …]\" suggestions, and the **Policies** sidebar item with document browsing and chat.",
    },
    {
      type: "callout",
      tone: "tip",
      title: "Municipal code",
      text: "Upload it as its own document with the statute type. Code sections then appear in the Statutes panel with a Dept badge and are cited in place of state law when they fit.",
    },
    {
      type: "paragraph",
      text: "To see what officers get from this, read Browse department documents and Policy check suggestions.",
    },
  ],
  related: ["search-and-ask", "policy-check-suggestions", "statutes"],
};

export default lesson;
